<template>
  <ValidationProvider
    v-slot="{ errors, valid, validated }"
    :name="name"
    :rules="getValidation"
    slim
  >
    <basic-form-group
      :id="id"
      :label-is-up="labelIsUp"
      :label="$attrs.label"
      :hint="$attrs.hint"
      :required="$attrs.required"
      :horizontal="$attrs.horizontal"
    >
      <div class="d-flex">
        <div class="w-100">
          <input
            :id="id"
            v-model="model"
            :class="{'is-invalid': !valid && validated}"
            :name="name"
            v-bind="$attrs"
            :min="$attrs.min"
            :max="$attrs.max"
            :step="$attrs.step"
            type="range"
            class="custom-range"
            v-on="listeners"
          >
          <div class="value-wrapper">
            <span
              class="text-nowrap"
              :style="{'left': getValuePosition()+'%'}"
            >{{ formattedValue }}<template v-if="suffix"> {{ suffix }}</template></span>
            <i
              :style="{'left': getValuePosition()+'%'}"
              class="fas fa-caret-up"
            />
          </div>
        </div>
      </div>
    </basic-form-group>
  </ValidationProvider>
</template>

<script>
import basicComponentMixin from './basic-component-mixin.js'
export default {
  name: 'BasicSlider',
  mixins: [basicComponentMixin],
  props: {
    suffix: {
      type: String,
      default: ''
    },
    formatter: {
      type: Function,
      default: (val) => val
    }
  },
  computed: {
    formattedValue () {
      return this.formatter(this.value)
    }
  },
  methods: {
    getValuePosition () {
      let hundred = this.$attrs.max - this.$attrs.min
      let value = this.value - this.$attrs.min
      return (value / hundred) * 100
    }
  }
}
</script>

<style lang="scss" scoped>
.min-max{
  margin-bottom: 7px;
}
.value-wrapper{
  position: relative;
  height: 27px;
  margin-left: 8px;
  margin-right: 8px;
  span{
    background-color: #0073be;
    padding-left: 5px;
    padding-right: 5px;
    border-radius: 5px;
    color: white;
    position: absolute;
    transform: translateX(-50%);
  }
  i{
    position: absolute;
    transform: translateX(-50%);
    top: -10px;
    color: #0073be;
  }
}
</style>
